import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCompany } from 'contexts/CompanyContext';
import { ROUTES } from 'constants/routes';
import { Loader2 } from 'lucide-react';

/**
 * CompanyHomeRedirect
 *
 * This component handles the default home route by redirecting users to:
 * 1. The selected company's dashboard if a company is selected
 * 2. The first company's dashboard if no selection but companies exist
 * 3. The companies decision hub if user has no companies
 */
export default function CompanyHomeRedirect({
  routeBuilder = ROUTES.COMPANY_DASHBOARD,
}) {
  const navigate = useNavigate();
  const { selectedCompany, companies, isLoading, hasCompanies } = useCompany();

  useEffect(() => {
    if (isLoading) return;

    if (selectedCompany?.id) {
      // User has a selected company - go to its dashboard
      navigate(routeBuilder(selectedCompany.id), { replace: true });
    } else if (hasCompanies && companies.length > 0) {
      // No selection but has companies - go to first company's dashboard
      navigate(routeBuilder(companies[0].id), { replace: true });
    } else {
      // No companies - go to the decision hub
      navigate(ROUTES.EMPRESAS, { replace: true });
    }
  }, [
    isLoading,
    selectedCompany,
    companies,
    hasCompanies,
    navigate,
    routeBuilder,
  ]);

  // Show loading spinner while determining where to redirect
  return (
    <div className="flex h-screen w-full items-center justify-center bg-[var(--rely-surface-page)] text-[var(--rely-text-muted)]">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-[var(--rely-color-brand-green)]" />
        <p className="text-sm text-[var(--rely-text-muted)]">
          Loading...
        </p>
      </div>
    </div>
  );
}
